<template>
  <div class="fill-height">
    <iframe
      v-if="html"
      class="app-update-frame"
      :srcdoc="html"
      :title="title"
      sandbox="allow-popups allow-popups-to-escape-sandbox"
    ></iframe>
    <v-layout v-else align-center justify-center fill-height>
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-circular>
      <div v-else class="grey--text">This update could not be found.</div>
    </v-layout>
  </div>
</template>

<script>
import fb from "@/main";

// "What's new in the apps" update for the business. Each issue is a full HTML
// page on appUpdates/{updateId}, loaded by alba-demo-scripts/publishAppUpdate.js.
// Nothing in the nav links here; the URL goes out by email. The page renders
// in a sandboxed iframe so its own styles and Vuetify's stay apart.
export default {
  name: "AppUpdate",
  data: () => ({
    loading: true,
    html: "",
    title: "",
  }),
  async created() {
    this.defaultTitle = document.title;
    try {
      const doc = await fb.db
        .collection("appUpdates")
        .doc(this.$route.params.updateId)
        .get();
      if (doc.exists) {
        const { html, title } = doc.data();
        this.title = title || "";
        this.html = html || "";
        if (title) document.title = title;
      }
    } catch (e) {
      console.error("Could not load the app update", e);
    }
    this.loading = false;
  },
  beforeDestroy() {
    document.title = this.defaultTitle;
  },
};
</script>

<style scoped>
.app-update-frame {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
</style>
